// extracted by mini-css-extract-plugin
module.exports = {"linkContainer":"plan-site-module--link-container--2s3HY","linksTitle":"plan-site-module--links-title--SuTTo"};